import { NgModule } from '@angular/core';
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { SchedulerModule } from "@progress/kendo-angular-scheduler"
import { EditorModule } from "@progress/kendo-angular-editor";
import { UploadModule } from "@progress/kendo-angular-upload";
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { GaugesModule } from "@progress/kendo-angular-gauges";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { ListViewModule } from "@progress/kendo-angular-listview";
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PopupModule } from "@progress/kendo-angular-popup";
import { SliderModule } from '@progress/kendo-angular-inputs';
import { PagerModule } from '@progress/kendo-angular-pager';
import { LayoutModule } from "@progress/kendo-angular-layout";
import { ChartsModule } from "@progress/kendo-angular-charts";
import { TooltipsModule } from "@progress/kendo-angular-tooltip";
import { ProgressBarModule } from "@progress/kendo-angular-progressbar";

@NgModule({
  exports: [
    DateInputsModule, SchedulerModule, EditorModule, UploadModule, DialogsModule, InputsModule, LabelModule, ButtonsModule, GridModule, DropDownsModule, GaugesModule, ListViewModule, PDFExportModule, PopupModule, TreeViewModule, SliderModule, PagerModule, ChartsModule, LayoutModule, TooltipsModule,ProgressBarModule
  ]
})
export class KendoModule {}
